package com.sddamico.draftmachine.data

/**
 * Frontend mirror of the jvmMain `data/Enums.kt`. kotlinx-serialization encodes enums by name,
 * so the enum names must match the backend exactly (same package, same constant order not required).
 */

enum class Sport {
  NFL, MLB, NBA, NHL,
  NCAA_FOOTBALL, NCAA_BASKETBALL,
  GOLF, MENS_TENNIS, WOMENS_TENNIS,
  OTHER
}

enum class DraftOrder {
  SNAKE, LINEAR, LOTTERY, CUSTOM
}

enum class DraftStatus {
  SETUP, ACTIVE, COMPLETE, CANCELLED
}

enum class PickOrigin {
  TRADED, COMPENSATORY
}

/** External fantasy platform a league can be linked to. */
enum class ExternalProvider { FANTRAX, ESPN }

/** Lifecycle of one league ownership sync run. */
enum class OwnershipSyncStatus { PENDING, RUNNING, SUCCEEDED, FAILED }
